const colors = [
    "blue",
    "orange",
    "lightblue",
    "purple",
    "yellow",
    "green",
    "copper",
    "pink",
    "grey",
    "teal"
];

const colorMap = {
    "REPORT-TYPE-A" : "orange",
    "REPORT-TYPE-H" : "lightpurple",
    "REPORT-TYPE-D" : "pink",
    "REPORT-TYPE-E" : "lightblue",
    "REPORT-TYPE-F" : "purple",
    "REPORT-TYPE-G" : "yellow",
    "REPORT-TYPE-L" : "blue",
    "REPORT-TYPE-O" : "green",
    "REPORT-TYPE-P" : "copper",
    "REPORT-TYPE-T" : "teal",
    "REPORT-TYPE-I" : "grey"
};

export function mappedColor( code ) {
    return colorMap[ code ];
}

export function randColor() {
    return colors[ Math.floor(Math.random() * colors.length ) ];
}

export function sectionColor( number ) {
    var lastDigit = +number.toString().split('').pop();
    
    return colors[ parseInt( lastDigit ) ];
}

